import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles';
import { BillsFontIcon } from '../../components/CustomIcons';
import theme, { commonFont } from '../../theme.css';
import CustomSection from '../../components/CustomSection';
import CustomTable from '../../components/CustomTable';
import {cyan} from '@mui/material/colors';

const useStyles = makeStyles((theme) => ({
    main: {
        padding: theme.spacing(2),
        background: theme.palette.common.white,
    },
    //table: 
    cell: {
        fontFamily: commonFont.regular,
    },
    columnSeparator: {
        display: 'none!important'
    },
    box: {
        background: cyan['A400'],
        color: theme.palette.common.white,
        padding: theme.spacing(2, 3),
        borderRadius: theme.spacing(0.5)
    }
}));

export default function BillsView(props){
    const classes = useStyles();
    const {t} = useTranslation();
    const {rows, columns } = props;

    return (
        <Grid item xs={12} className={classes.main}>
            <CustomSection notMarginTop={true} 
                title={t('bills')} 
                icon={<BillsFontIcon style={{
                    color: theme.palette.common.white,
                }}/>}
                customClass={classes.customClass}
            >
                <Grid item xs={12} sm={4} marginTop={1} container direction='row' className={classes.box}>
                    <Grid item xs={4}>
                        <BillsFontIcon style={{
                            color: theme.palette.common.white,
                            fontSize: '3em'
                        }}/>
                    </Grid>
                    <Grid item xs={8} style={{textAlign: 'right'}}>
                        <Typography variant='body1'>{t('outstanding_amount')}</Typography>
                        <Typography variant='body2'>{0}</Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} marginTop={1}>
                    <CustomTable 
                        showHeader={true}
                        rows={rows}
                        columns={columns}
                        columnAction={true}
                        action={{
                            title: t('bill_view'),
                        }}
                        onClick={props.onDetail}
                    />
                </Grid>
            </CustomSection>
        </Grid>
    );
}
